require("@rails/ujs").start()
require("@rails/activestorage").start()
require("channels")
require("turbolinks").start()